import { render, staticRenderFns } from "./CompleteTicketDialog.vue?vue&type=template&id=6b11552c&"
import script from "./CompleteTicketDialog.vue?vue&type=script&lang=js&"
export * from "./CompleteTicketDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompleteTicketDialog.vue?vue&type=style&index=0&id=6b11552c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog})
